import { createGenericReducer } from "common/genericReducer";
import { RequestState } from "common/RequestState";
import reduceReducers from "reduce-reducers";
import {
  DELETE_PROJECT_RECEIVED,
  DELETE_PROJECT_REQUESTED,
  DELETE_PROJECT_REQUEST_FAILED,
  DELETE_PROJECT_RESET,
  SAVED_PROJECTS_RECEIVED,
  SAVED_PROJECTS_REQUESTED,
  SAVED_PROJECTS_REQUEST_FAILED
} from "./projectActions";

const mapToObject = items => {
  const result = {};
  items.forEach(c => {
    c.requestState = RequestState.Finished;
    result[c.Id] = c;
  });
  return result;
};

const mapPages = (state, pageSize, pageNumber, total, items) => {
  // remove saved pages if total or pageSize has changed
  if (state && state.total === total && state.pageSize === pageSize) return { ...state.pages, [pageNumber]: items };
  return { [pageNumber]: items };
};

const generatePayload = (state, pageSize, pageNumber, total, items) => {
  const pages = mapPages(state, pageSize, pageNumber, total, items.map(project => project.Id));

  return {
    ...mapToObject(items),
    pageSize: pageSize,
    total: total,
    pages: pages
  };
};

const createSavedProjectsReducer = () => {
  const customReducer = (state, action) => {
    switch (action.type) {
      case SAVED_PROJECTS_RECEIVED:
        const { pageSize, pageNumber, total, items } = action;
        return {
          ...state,
          ...generatePayload(state, pageSize, pageNumber, total, items),
          requestState: RequestState.Finished
        };
      default:
        return state;
    }
  };
  return createGenericReducer(SAVED_PROJECTS_REQUESTED, null, SAVED_PROJECTS_REQUEST_FAILED, null, customReducer);
};

const createDeleteReducer = () => (state = {}, action) => {
  const internalReducer = createGenericReducer(
    DELETE_PROJECT_REQUESTED,
    DELETE_PROJECT_RECEIVED,
    DELETE_PROJECT_REQUEST_FAILED,
    DELETE_PROJECT_RESET,
    null
  );

  return { ...state, delete: internalReducer(state.delete, action) };
};

export const projects = reduceReducers(createSavedProjectsReducer(), createDeleteReducer());
